import React from "react";

const CaseStudyFooterTitle = () => (
  <>We bring products to life.<br/>Let's build yours.</>
);

export default CaseStudyFooterTitle;
